import type { AllRouteEndpoints } from "../routeTypes";
export const deleteQueryBuilderReportCacheKeys: AllRouteEndpoints[] = [];
